import { ref } from "vue";
import {
  statusFilters,
  StatusFiltersLabels,
  StatusFiltersValues,
} from "@/constants/statusFilters";

export function useLotsFiltering() {
  const blacklistedStatuses = [
    StatusFiltersValues.OFFLINE,
    StatusFiltersValues.EOI,
    StatusFiltersValues.CONTRACT_EXECUTED,
    StatusFiltersValues.OPTION,
  ];
  const filters = statusFilters.filter(
    (filter) => !blacklistedStatuses.includes(filter.value)
  );
  const activeFilter = ref(filters[0]);
  const viewType = ref<"list" | "map">("list");

  const changeFilter = (item: {
    label: StatusFiltersLabels;
    value: StatusFiltersValues;
  }) => {
    activeFilter.value = item;
  };

  return {
    filters,
    activeFilter,
    viewType,
    changeFilter,
  };
}
